(() => {
  function initTabs() {
    document.querySelectorAll('.custom-tabs:not([initialized])').forEach((section) => {
      // Mark as initialized so we don't attach listeners twice
      section.setAttribute('initialized', 'true');

      // --- 1. Main Tab Navigation Logic ---
      const tabButtons = section.querySelectorAll('.custom-tabs__tab-btn');
      
      tabButtons.forEach((btn) => {
        btn.addEventListener('click', (event) => {
          const targetTabId = btn.getAttribute('data-tab-target');

          // Update button states using the BEM modifier
          tabButtons.forEach((b) => b.classList.remove('custom-tabs__tab-btn--active'));
          btn.classList.add('custom-tabs__tab-btn--active');

          // Update content visibility using the BEM modifier
          section.querySelectorAll('.custom-tabs__content').forEach((content) => {
            content.classList.remove('custom-tabs__content--active');
          });
          
          const targetContent = section.querySelector(`#${targetTabId}`);
          if (targetContent) {
            targetContent.classList.add('custom-tabs__content--active');
          }
        });
      });

      // --- 2. Product Switching Logic ---
      const thumbnails = section.querySelectorAll('.custom-tabs__thumb');
      
      thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', (event) => {
          const blockId = thumb.getAttribute('data-product-target');

          // Update Thumbnail rings using the BEM modifier
          thumbnails.forEach((t) => t.classList.remove('custom-tabs__thumb--active'));
          thumb.classList.add('custom-tabs__thumb--active');

          // Fade out active items
          const images = section.querySelectorAll('.custom-tabs__product-image-item');
          const specs = section.querySelectorAll('.custom-tabs__product-specs-item');

          images.forEach((item) => {
            item.style.opacity = '0';
            setTimeout(() => item.classList.remove('custom-tabs__product-image-item--active'), 300);
          });

          specs.forEach((item) => {
            item.style.opacity = '0';
            setTimeout(() => item.classList.remove('custom-tabs__product-specs-item--active'), 300);
          });

          // Fade in newly selected items
          setTimeout(() => {
            const targetImage = section.querySelector(`#img-${blockId}`);
            const targetSpecs = section.querySelector(`#specs-${blockId}`);

            if (targetImage) {
              targetImage.classList.add('custom-tabs__product-image-item--active');
              setTimeout(() => (targetImage.style.opacity = '1'), 50);
            }

            if (targetSpecs) {
              targetSpecs.classList.add('custom-tabs__product-specs-item--active');
              setTimeout(() => (targetSpecs.style.opacity = '1'), 50);
            }
          }, 300);
        });
      });
    });
  }

  // Run when the DOM is fully loaded on the live site
  document.addEventListener('DOMContentLoaded', initTabs);

  // Run when a section is loaded or updated inside the Shopify Theme Editor
  document.addEventListener('shopify:section:load', initTabs);
})();